"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutRegisterContextProvider = exports.useCheckoutRegister = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _agent = require("@deosite/agent");
var _CartProvider = require("./CartProvider");
var _TokenProvider = require("../common/TokenProvider");
var _useAppConfiguration2 = _interopRequireDefault(require("@deosite/app/features/appConfiguration/useAppConfiguration"));
var _router = require("next/router");
var _OrdersProvider = require("./OrdersProvider");
var _EPoints = require("./EPoints");
var _useErrorCheckout2 = _interopRequireDefault(require("../common/useErrorCheckout"));
var _useProductsBySkus = require("./useProductsBySkus");
var _useCheckoutData2 = _interopRequireDefault(require("../redux/useCheckoutData"));
var _useCategoryTree2 = require("../common/useCategoryTree");
var _useAnalytics4AndCommerceTags = _interopRequireDefault(require("../common/useAnalytics4AndCommerceTags"));
var _useShippingMethods2 = _interopRequireDefault(require("../redux/useShippingMethods"));
var _useSalesmanago = _interopRequireDefault(require("./useSalesmanago"));
var _useAdyenCheckout2 = _interopRequireDefault(require("../common/useAdyenCheckout"));
var _MessageHandlerProvider = require("../common/MessageHandlerProvider");
var _createParametrizedUrl = _interopRequireDefault(require("@deosite/helpers/createParametrizedUrl"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _handleAdyenErrorMessage = _interopRequireDefault(require("@deosite/helpers/handleAdyenErrorMessage"));
var _sentry = require("@deosite/helpers/sentry");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CheckoutRegisterContext = /*#__PURE__*/_react["default"].createContext();
var orderIdCookieName = global.__appConfig__.orderIdCookieName;
var CheckoutRegisterContextProvider = function CheckoutRegisterContextProvider(props) {
  var _useState = (0, _react.useState)(false),
    isPageLocked = _useState[0],
    setPageLocked = _useState[1];
  var _useState2 = (0, _react.useState)(null),
    tokenNewRegister = _useState2[0],
    setTokenNewRegister = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    hadError = _useState3[0],
    setHadError = _useState3[1];
  var router = (0, _router.useRouter)();
  var _useHandleMessage = (0, _MessageHandlerProvider.useHandleMessage)(),
    handleMessage = _useHandleMessage.handleMessage;
  var _useAppConfiguration = (0, _useAppConfiguration2["default"])(),
    language = _useAppConfiguration.language,
    domain = _useAppConfiguration.domain;
  var _useToken = (0, _TokenProvider.useToken)(),
    token = _useToken.token;
  var _useCart = (0, _CartProvider.useCart)(),
    truncateCart = _useCart.truncateCart,
    cart = _useCart.cart,
    addCouponCode = _useCart.addCouponCode,
    getCartTotals = _useCart.getCartTotals,
    setProductsWithQuantity = _useCart.setProductsWithQuantity,
    handleResponseErrors = _useCart.handleResponseErrors,
    clearCart = _useCart.clearCart;
  var _useOrders = (0, _OrdersProvider.useOrders)(),
    removeUserOrders = _useOrders.removeUserOrders;
  var _useEPoints = (0, _EPoints.useEPoints)(),
    clearEPoints = _useEPoints.clearEPoints;
  var _useCategoryTree = (0, _useCategoryTree2.useCategoryTree)(),
    getCategoryNameForGivenCategoryId = _useCategoryTree.getCategoryNameForGivenCategoryId;
  var _useCheckoutData = (0, _useCheckoutData2["default"])(),
    billingAddress = _useCheckoutData.billingAddress,
    email = _useCheckoutData.email,
    emailConsentForDelivery = _useCheckoutData.emailConsentForDelivery,
    updateOrderId = _useCheckoutData.updateOrderId;
  var handleSalesmanagoEvent = (0, _useSalesmanago["default"])();
  var _useAnalyticsAndComme = (0, _useAnalytics4AndCommerceTags["default"])(),
    cartPurchased = _useAnalyticsAndComme.cartPurchased;
  var _useShippingMethods = (0, _useShippingMethods2["default"])(),
    selectedShippingMethod = _useShippingMethods.selectedShippingMethod;
  var translations = {
    error: (0, _langLibrary["default"])("Error"),
    something: (0, _langLibrary["default"])("Something went wrong"),
    adyenPaymentRefused: (0, _langLibrary["default"])("adyen_error_message"),
    adyenPaymentRefusedNoAmount: (0, _langLibrary["default"])("adyen_error_message_amount_exceeded")
  };
  var _useErrorCheckout = (0, _useErrorCheckout2["default"])(),
    checkError = _useErrorCheckout.checkError;
  var _useAdyenCheckout = (0, _useAdyenCheckout2["default"])({
      setPageLocked: setPageLocked
    }),
    handleAdyenPayment = _useAdyenCheckout.handleAdyenPayment;
  var clearCheckoutData = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              clearEPoints();
              _context.next = 3;
              return truncateCart();
            case 3:
              _context.next = 5;
              return removeUserOrders();
            case 5:
              clearCart();
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "checkout_success"
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function clearCheckoutData() {
      return _ref.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    if (isPageLocked && router.pathname && !router.pathname.includes("payment")) {
      setPageLocked(false);
    }
  }, [router === null || router === void 0 ? void 0 : router.pathname]);
  var sendPaymentInformation = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref2) {
      var _values$paymentMethod, _values$adyenPayload, _values$adyenPayload2, _additional_data$bran;
      var values, onSuccess, onError, isAdyen, method, additional_data, adyenInfo, street, payload, url, _additional_data$bran2, paymentResponse, _getCartTotals$coupon, _getCartTotals, _values$paymentMethod2, isPayPal, orderData, cartTotals, _err$response, _err$response2, _err$response2$body, is404, skus, _additional_data$bran3, errorTranslate;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              values = _ref2.values, onSuccess = _ref2.onSuccess, onError = _ref2.onError;
              if (!(!billingAddress || !(cart !== null && cart !== void 0 && cart.id))) {
                _context2.next = 4;
                break;
              }
              onError({
                globalErrors: [{
                  level: "negative",
                  title: translations.error,
                  description: checkError(_useErrorCheckout2["default"].ADDRESS_NOT_SET)
                }]
              });
              return _context2.abrupt("return");
            case 4:
              isAdyen = (_values$paymentMethod = values.paymentMethod) === null || _values$paymentMethod === void 0 ? void 0 : _values$paymentMethod.adyen;
              method = isAdyen ? values.paymentMethod.adyen : values.paymentMethod.id;
              additional_data = isAdyen ? values === null || values === void 0 ? void 0 : (_values$adyenPayload = values.adyenPayload) === null || _values$adyenPayload === void 0 ? void 0 : _values$adyenPayload.additionalData : {};
              adyenInfo = isAdyen ? {
                authenticationData: {
                  threeDSRequestData: {
                    nativeThreeDS: "preferred"
                  }
                },
                browserInfo: (_values$adyenPayload2 = values.adyenPayload) === null || _values$adyenPayload2 === void 0 ? void 0 : _values$adyenPayload2.browserInfo,
                channel: "Web",
                origin: "https://".concat(domain, "/")
              } : {};
              street = Array.isArray(billingAddress.street) ? billingAddress.street : [billingAddress.street];
              payload = _objectSpread({
                email: email,
                paymentMethod: {
                  method: method,
                  additional_data: additional_data
                },
                billing_address: {
                  email: email,
                  country_id: billingAddress.country.id,
                  street: emailConsentForDelivery ? [billingAddress.street, "Wyrażono zgodę na przekazanie adresu email kurierowi"] : street,
                  postcode: billingAddress.postalCode,
                  city: billingAddress.city,
                  telephone: billingAddress.phone,
                  firstname: billingAddress.firstName,
                  lastname: billingAddress.lastName,
                  company: billingAddress.companyName,
                  vat_id: billingAddress.vatId
                }
              }, adyenInfo);
              url = token ? global.__appConfig__.customerPlaceOrderUrl : (0, _createParametrizedUrl["default"])(global.__appConfig__.guestPlaceOrderUrl, {
                cartId: cart.id
              });
              if (additional_data !== null && additional_data !== void 0 && (_additional_data$bran = additional_data.brand_code) !== null && _additional_data$bran !== void 0 && _additional_data$bran.includes("blik")) {
                (0, _sentry.logBlik)({
                  eventType: "message",
                  eventName: "before_request_payment-information",
                  contextData: {
                    payload: payload,
                    additional_data: additional_data
                  }
                });
              }
              _context2.prev = 12;
              _context2.next = 15;
              return _agent.requests.post(url, payload, token, {
                language: language,
                domain: domain
              });
            case 15:
              paymentResponse = _context2.sent;
              if (additional_data !== null && additional_data !== void 0 && (_additional_data$bran2 = additional_data.brand_code) !== null && _additional_data$bran2 !== void 0 && _additional_data$bran2.includes("blik")) {
                (0, _sentry.logBlik)({
                  eventType: "message",
                  eventName: "after_request_payment-information",
                  contextData: {
                    paymentResponse: paymentResponse
                  }
                });
              }
              if (onSuccess) {
                cart.items.map(function (item, index) {
                  var _item$product, _item$product$categor;
                  cart.items[index].categoryName = getCategoryNameForGivenCategoryId((_item$product = item.product) === null || _item$product === void 0 ? void 0 : (_item$product$categor = _item$product.category) === null || _item$product$categor === void 0 ? void 0 : _item$product$categor.id);
                });
                isPayPal = paymentResponse.includes("paypal");
                orderData = JSON.parse(paymentResponse);
                cartTotals = {
                  shippingTotal: getCartTotals().shippingCost,
                  subtotalPrice: getCartTotals().productsTotalPrice,
                  discountPrice: getCartTotals().discount,
                  totalPrice: getCartTotals().cartTotalPrice,
                  tax: getCartTotals().tax
                };
                cartPurchased(cart, cartTotals, language, isPayPal ? cart.id : orderData.orderId, (_getCartTotals$coupon = (_getCartTotals = getCartTotals()) === null || _getCartTotals === void 0 ? void 0 : _getCartTotals.couponCode) !== null && _getCartTotals$coupon !== void 0 ? _getCartTotals$coupon : "");
                _jsCookie["default"].remove(global.__appConfig__.shippingMethodIdCookieName);
                handleSalesmanagoEvent("PURCHASE", {
                  email: cart.billingAddress.email,
                  products: cart.items.map(function (item) {
                    return item.sku;
                  }),
                  value: cartTotals.totalPrice,
                  details: [cart.currency, selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.label, (_values$paymentMethod2 = values.paymentMethod) === null || _values$paymentMethod2 === void 0 ? void 0 : _values$paymentMethod2.label]
                });
                onSuccess(orderData);
              }
              _context2.next = 40;
              break;
            case 20:
              _context2.prev = 20;
              _context2.t0 = _context2["catch"](12);
              is404 = false;
              if ((_context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_err$response = _context2.t0.response) === null || _err$response === void 0 ? void 0 : _err$response.statusCode) === 400) {
                // Sentry.captureException({
                //   err,
                //   payload,
                //   paymentAdditionalData: payload.paymentMethod.additional_data
                // });
                is404 = true;
                skus = [];
                cart.items.forEach(function (item) {
                  skus.push(item.product.sku);
                });
                (0, _useProductsBySkus.fetcher)({
                  skus: skus.toString(),
                  pageSize: 250,
                  language: {
                    language: language,
                    domain: domain
                  },
                  getQuantity: true,
                  visibility: true
                }).then(function (response) {
                  var skusAndQuantity = [];
                  response.forEach(function (item) {
                    skusAndQuantity.push({
                      sku: item.sku,
                      quantity: item.availability.quantity
                    });
                  });
                  setProductsWithQuantity(skusAndQuantity);
                });
              }
              if (!isAdyen) {
                _context2.next = 36;
                break;
              }
              if (!(additional_data !== null && additional_data !== void 0 && (_additional_data$bran3 = additional_data.brand_code) !== null && _additional_data$bran3 !== void 0 && _additional_data$bran3.includes("blik"))) {
                _context2.next = 34;
                break;
              }
              (0, _sentry.logBlik)({
                eventType: "message",
                eventName: "after_request_error_payment-information",
                contextData: {
                  additional_data: additional_data,
                  err: _context2.t0
                }
              });
              if (!_context2.t0.message.includes("Request has been terminated")) {
                _context2.next = 34;
                break;
              }
              (0, _sentry.logBlik)({
                eventType: "message",
                eventName: "request_has_been_terminated",
                contextData: {
                  additional_data: additional_data,
                  err: _context2.t0
                },
                level: "error"
              });
              _context2.next = 31;
              return clearCheckoutData();
            case 31:
              _jsCookie["default"].remove(orderIdCookieName);
              router.push("/checkout/success-partial");
              return _context2.abrupt("return");
            case 34:
              setHadError(404);
              (0, _handleAdyenErrorMessage["default"])({
                message: is404 ? translations.adyenPaymentRefusedNoAmount : translations.adyenPaymentRefused
              }, values.adyenPayload.component, handleMessage);
            case 36:
              handleResponseErrors(_context2.t0);
              errorTranslate = checkError(_context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_err$response2 = _context2.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$body = _err$response2.body) === null || _err$response2$body === void 0 ? void 0 : _err$response2$body.message);
              onError(isAdyen ? null : {
                fieldErrors: errorTranslate,
                globalErrors: [{
                  level: "negative",
                  title: translations.error,
                  description: errorTranslate
                }]
              });
              setPageLocked(false);
            case 40:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[12, 20]]);
    }));
    return function sendPaymentInformation(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    var _JSON$parse;
    var setShippingAndPaymentInformation = /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _agent.requests.post(global.__appConfig__.customerSetShippingInformation, tokenNewRegister.payload, token, {
                  language: language,
                  domain: domain
                });
              case 2:
                _context3.next = 4;
                return paymentInformation(tokenNewRegister.values, {
                  setErrors: tokenNewRegister.setErrors
                }, tokenNewRegister.alert);
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return function setShippingAndPaymentInformation() {
        return _ref4.apply(this, arguments);
      };
    }();
    if (tokenNewRegister && (tokenNewRegister === null || tokenNewRegister === void 0 ? void 0 : tokenNewRegister.customerCartId) === (cart === null || cart === void 0 ? void 0 : cart.id) && token && ((_JSON$parse = JSON.parse(localStorage.getItem("minicartContent"))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.id) > 0) {
      setTokenNewRegister(null);
      setPageLocked(true);
      if (tokenNewRegister.payload.couponCode) {
        addCouponCode(tokenNewRegister.payload.couponCode).then(_agent.requests.post(global.__appConfig__.customerSetShippingInformation, tokenNewRegister.payload, token, {
          language: language,
          domain: domain
        })).then(function () {
          paymentInformation(tokenNewRegister.values, {
            setErrors: tokenNewRegister.setErrors
          }, tokenNewRegister.alert).then(function () {});
        });
      } else {
        setShippingAndPaymentInformation().then()["catch"](function (err) {
          console.log("Error pay on register user", err);
          handleResponseErrors(err);
          setPageLocked(false);
        });
      }
    }
  }, [tokenNewRegister === null || tokenNewRegister === void 0 ? void 0 : tokenNewRegister.customerCartId, cart === null || cart === void 0 ? void 0 : cart.id, token]);
  var paymentInformation = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(values, _ref5, alert) {
      var setErrors;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              setErrors = _ref5.setErrors;
              setPageLocked(true);
              _context5.prev = 2;
              setPageLocked(true);
              _context5.next = 6;
              return sendPaymentInformation({
                values: values,
                onError: function onError(errors) {
                  setPageLocked(false);
                  if (errors.globalErrors.length > 0) {
                    alert.show({
                      payload: errors.globalErrors[0]
                    });
                  }
                  var adyenComponent = values.adyenPayload.component;
                  if (adyenComponent) {
                    values.adyenPayload.component.unmount();
                    values.adyenPayload.component.mount(values.adyenPayload.component.elementRef.elementRef._node);
                  }
                  // setErrors(errors.fieldErrors); // TODO: sprawdzić czy potrzebne? zabija zmiane formy platnosci po 400 na POST payment-information
                },
                onSuccess: function () {
                  var _onSuccess = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(orderData) {
                    var redirectUrl, orderId, isAdyenPayment, _adyenResponse$action, _adyenResponse$action2, _adyenResponse$action3, adyenResponse;
                    return _regenerator["default"].wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            redirectUrl = orderData.redirectUrl, orderId = orderData.orderId;
                            isAdyenPayment = redirectUrl === null || redirectUrl === void 0 ? void 0 : redirectUrl.includes("adyen");
                            if (isAdyenPayment) {
                              _context4.next = 12;
                              break;
                            }
                            setPageLocked(true);
                            clearEPoints();
                            _context4.next = 7;
                            return truncateCart();
                          case 7:
                            _context4.next = 9;
                            return removeUserOrders();
                          case 9:
                            clearCart();
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                              event: "checkout_success"
                            });
                          case 12:
                            if (!redirectUrl) {
                              _context4.next = 23;
                              break;
                            }
                            if (!isAdyenPayment) {
                              _context4.next = 20;
                              break;
                            }
                            _context4.next = 16;
                            return handleAdyenPayment({
                              orderId: orderId,
                              component: values.adyenPayload.component
                            });
                          case 16:
                            adyenResponse = _context4.sent;
                            if (!(adyenResponse !== null && adyenResponse !== void 0 && adyenResponse.isFinal) && adyenResponse !== null && adyenResponse !== void 0 && (_adyenResponse$action = adyenResponse.action) !== null && _adyenResponse$action !== void 0 && (_adyenResponse$action2 = _adyenResponse$action.type) !== null && _adyenResponse$action2 !== void 0 && (_adyenResponse$action3 = _adyenResponse$action2.includes) !== null && _adyenResponse$action3 !== void 0 && _adyenResponse$action3.call(_adyenResponse$action2, "threeDS2")) {
                              setPageLocked(false);
                            }
                            _context4.next = 21;
                            break;
                          case 20:
                            window.location.replace(redirectUrl.replace(/^.*\/\/[^\/]+/, ""));
                          case 21:
                            _context4.next = 24;
                            break;
                          case 23:
                            if (orderId > 0) {
                              router.push("/checkout/success").then(function () {
                                return setPageLocked(false);
                              });
                            }
                          case 24:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));
                  function onSuccess(_x5) {
                    return _onSuccess.apply(this, arguments);
                  }
                  return onSuccess;
                }()
              });
            case 6:
              _context5.next = 11;
              break;
            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](2);
              setPageLocked(false);
            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[2, 8]]);
    }));
    return function paymentInformation(_x2, _x3, _x4) {
      return _ref6.apply(this, arguments);
    };
  }();
  return __jsx(CheckoutRegisterContext.Provider, {
    value: {
      isPageLocked: isPageLocked,
      setPageLocked: setPageLocked,
      hadError: hadError,
      setHadError: setHadError,
      setTokenNewRegister: setTokenNewRegister,
      paymentInformation: paymentInformation
    }
  }, props.children);
};
exports.CheckoutRegisterContextProvider = CheckoutRegisterContextProvider;
var useCheckoutRegister = function useCheckoutRegister() {
  var context = (0, _react.useContext)(CheckoutRegisterContext);
  if (!context) {
    throw new Error("useCheckoutRegister must be used within a CheckoutRegisterContext");
  }
  return context;
};
exports.useCheckoutRegister = useCheckoutRegister;